import DeliveryThresholdUI from "./DeliveryThresholdUI";
import { useEffect, useState } from "react";
import { StandardProps } from "@/components/componentMap";

export const DeliveryThreshold = ({
  experiencesRawObject,
}: Pick<StandardProps, "experiencesRawObject">) => {
  const [showPortal, setShowPortal] = useState(false);

  useEffect(() => {
    setShowPortal(true);
  }, []);

  return (
    <DeliveryThresholdUI
      experiencesRawObject={experiencesRawObject}
      showPortal={showPortal}
    />
  );
};
